<template>
  <div class="relative flex flex-col items-center justify-center h-full px-40">
    <section-title title-path="title-1.png" />
    <div
      class="row w-full max-w-1280 flex flex-wrap justify-center mt-14 z-10 xl:max-w-928 xl:mt-6"
    >
      <div
        v-for="(content, index) in contents"
        :key="content"
        :style="{
          'background-image':
            'url(' +
            imgPath +
            '/slide2/content' +
            (index + 1) +
            '_sprites.png)',
        }"
        class="menu-btn relative inline-block w-236 h-232 m-1 bg-10-10 bg-auto bg-no-repeat cursor-pointer xl:bg-cover xl:w-172 xl:h-176 xl:bg-4-4"
        @click="handleSlide(index)"
      >
        <span
          class="menu-btn-hover"
          :style="{
            'background-image':
              'url(' +
              imgPath +
              '/slide2/content' +
              (index + 1) +
              '_sprites.png)',
          }"
        ></span>
      </div>
    </div>
    <img
      class="bird absolute bottom-1/10 right-0.3/10 h-auto m-auto invisible xl:right-0"
      :src="imgPath + '/slide2/bird.png'"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import breakpoints from '@/plugins/breakpoints';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  name: 'content-section',
  components: {
    SectionTitle,
  },
  props: {
    moveTo: Function,
  },
  data: function() {
    return {
      breakpoints,
      imgPath: process.env.VUE_APP_IMG_URL,
      contents: [
        '/content1.png',
        '/content2.png',
        '/content3.png',
        '/content4.png',
        '/content5.png',
        '/content6.png',
        '/content7.png',
        '/content8.png',
        '/content9.png',
      ],
    };
  },
  methods: {
    handleSlide: function(index) {
      this.moveTo(index + 3);
    },
    initAnimation: function() {
      this.$store.commit('ANIMATION/INIT_CONTENT_SECTION_INNER');
    },
    disableAnimation: function() {
      this.$store.commit('ANIMATION/DISABLE_CONTENT_SECTION_INNER');
    },
  },
  computed: {
    ...mapState({
      activeSection: state => state.Fullpage.activeSection,
    }),
  },
  created: function() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.activeSection,
      (newValue, oldValue) => {
        //console.log(`Updating from ${oldValue} to ${newValue}`);
        if (newValue === 1 && this.breakpoints.w > 1366) {
          this.initAnimation();
        } else if (newValue != 1 && this.breakpoints.w > 1366) {
          this.disableAnimation();
        }
      },
    );
  },
  beforeDestroy() {
    this.unwatch();
  },
};
</script>

<style lang="postcss" scoped>
.menu-btn {
  text-indent: -9999px;
}
.menu-btn span {
  @apply absolute inset-0 bg-274-10 xl:invisible;
  content: '';
  opacity: 0;
  -webkit-transition: opacity 0.5s;
  -moz-transition: opacity 0.5s;
  -o-transition: opacity 0.5s;
}
.menu-btn:hover span {
  opacity: 1;
}
</style>
